<script setup>
import { ref, computed, defineProps, inject } from 'vue';
import GradeClassChart from '@/components/result/MLSRD-2026/GradeClassChart.vue'; 

// 반별 레벨 데이터 변환 함수
const convertToLevelData = (classItem, type) => {
  if (!classItem) return [];
  
  const levelData = [];
  
  if (type === 'literacy') {
    const total = classItem.korlevel1 + classItem.korlevel2 + classItem.korlevel3 + classItem.korlevel4 + classItem.female_korlevel1 + classItem.female_korlevel2 + classItem.female_korlevel3 + classItem.female_korlevel4;
    levelData.push(
      { level: '1수준', percentage: total > 0 ? Math.round(((classItem.korlevel1 + classItem.female_korlevel1) / total) * 100) : 0, count: classItem.korlevel1 + classItem.female_korlevel1 },
      { level: '2수준', percentage: total > 0 ? Math.round(((classItem.korlevel2 + classItem.female_korlevel2) / total) * 100) : 0, count: classItem.korlevel2 + classItem.female_korlevel2 },
      { level: '3수준', percentage: total > 0 ? Math.round(((classItem.korlevel3 + classItem.female_korlevel3) / total) * 100) : 0, count: classItem.korlevel3 + classItem.female_korlevel3 },
      { level: '4수준', percentage: total > 0 ? Math.round(((classItem.korlevel4 + classItem.female_korlevel4) / total) * 100) : 0, count: classItem.korlevel4 + classItem.female_korlevel4 }
    );
  } else {
    const total = classItem.matlevel1 + classItem.matlevel2 + classItem.matlevel3 + classItem.matlevel4 + classItem.female_matlevel1 + classItem.female_matlevel2 + classItem.female_matlevel3 + classItem.female_matlevel4;
    levelData.push(
      { level: '1수준', percentage: total > 0 ? Math.round(((classItem.matlevel1 + classItem.female_matlevel1) / total) * 100) : 0, count: classItem.matlevel1 + classItem.female_matlevel1 },
      { level: '2수준', percentage: total > 0 ? Math.round(((classItem.matlevel2 + classItem.female_matlevel2) / total) * 100) : 0, count: classItem.matlevel2 + classItem.female_matlevel2 },
      { level: '3수준', percentage: total > 0 ? Math.round(((classItem.matlevel3 + classItem.female_matlevel3) / total) * 100) : 0, count: classItem.matlevel3 + classItem.female_matlevel3 },
      { level: '4수준', percentage: total > 0 ? Math.round(((classItem.matlevel4 + classItem.female_matlevel4) / total) * 100) : 0, count: classItem.matlevel4 + classItem.female_matlevel4 }
    );
  }
  
  return levelData;
};

// 현재 페이지에 표시할 반들 (최대 3개)
const currentClasses = computed(() => {
  if (props.classesData && props.classesData.length > 0) {
    return props.classesData.slice(0, 3); // 최대 3개만
  }
  return [];
});

const schoolData = inject('schoolData');
const region = "seoul";

const props = defineProps({
    schoolType: {
        type: String, 
        required: true,
        validator: (value) => ['elementary', 'middle', 'high'].includes(value),
    },
    gradeCode: {
        type: String,
        default: ''
    },
    classesData: {
        type: Array,
        default: () => []
    }
});

const grade = computed(() => {
    // props로 gradeCode가 넘어오면 우선 사용
    if (props.gradeCode) {
        return props.gradeCode;
    }
    // 기본값
    if (props.schoolType === 'elementary') {
        return '4'; 
    } else if (props.schoolType === 'middle') {
        return '2'; 
    } else if (props.schoolType === 'high') {
        return '1'; 
    }
    return ''; 
});
</script>

<template>
  <div class="slide-inner">
    <div class="content">        
        <div class="page-title">수준별 학생 비율(수)</div>
        <h4 class="title-box mt-10" :class="[region, pagetype, `grade`+grade]">
            <template v-if="props.schoolType === 'elementary'">
              초등학교 {{ grade }}학년
            </template>
            <template v-else-if="props.schoolType === 'middle'">
              중학교 {{ grade }}학년
            </template>
            <template v-else-if="props.schoolType === 'high'">
              고등학교 {{ grade }}학년
            </template>
            <template v-else>
              {{ grade }}학년
            </template>
          </h4>       
        <div class="card-wrap">
            <div v-for="classItem in currentClasses" :key="classItem.school_cls" class="card pt-5">
                <h5 class="card-title">{{ grade }}학년 {{ classItem.school_cls }}반</h5>
                <n-flex :wrap="false" :size="30" class="pt-5">            
                    <GradeClassChart
                        :grade-title="grade"
                        :class-num="classItem.school_cls"
                        chart-type="literacy"       
                        :level-data="convertToLevelData(classItem, 'literacy')"
                        :max-scale="100"
                        chart-height="220px"
                    />       
                    <GradeClassChart
                        :grade-title="grade"
                        :class-num="classItem.school_cls"
                        chart-type="numeracy"     
                        :level-data="convertToLevelData(classItem, 'numeracy')"
                        :max-scale="100"
                        chart-height="220px"
                    />
                </n-flex>
            </div>
        </div>      
    </div>
  </div>
</template>